import { useMemo } from "react";
import sheffieldBack from "@/assets/sheffield-back.webp";

// Pool of wallpaper images for the login experience - add more entries here as needed.
const WALLPAPER_URLS = [sheffieldBack];

const RandomWallpaper = () => {
  // Select a random wallpaper on component mount
  const selectedWallpaper = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * WALLPAPER_URLS.length);
    return WALLPAPER_URLS[randomIndex];
  }, []);

  return (
    <div
      className="hidden bg-cover lg:block lg:w-1/2 xl:w-2/3"
      style={{
        backgroundImage: `url("${selectedWallpaper}")`,
        backgroundPosition: "50% 50%",
      }}
    ></div>
  );
};

export default RandomWallpaper;
